import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from 'react-datepicker'
import { Link } from "react-router-dom";
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';
import 'react-datepicker/dist/react-datepicker.css'
import es from "date-fns/locale/es";

registerLocale('es', es);

const Binnacle = () => {
    const [loading, setLoading] = useState(false);
    const [branchs, setBranchs] = useState([]);
    const [branch_id, setBranchId] = useState(0);
    const [date, setDate] = useState(new Date());
    const [times, setTimes] = useState([]);
    const [time, setTime] = useState('');
    const [binnacles, setBinnacles] = useState([]);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        getAllBranchs();
        setTimeout(() => {
            $('.select2').select2({ width: "100%", placeholder: "Seleccione" });
        }, 100);
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
        var table = $('.main').DataTable();
            table.destroy();
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 50,
                    responsive: true,
                    autoWidth: true,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar...",
                    },
                });
                setLoading(false);
            }, 100);
    }, []);

    $('#branch_id').on("change", function (e) {
        setTimes([]);
        setTime('');
        setBranchId(e.target.value);
        getSchedulesDay(e.target.value);
    });

    $('#time').on("change", function (e) {
        setTime(e.target.value);
    });

    const handleCalendarClose = () => {
        getSchedulesDay(branch_id);
    };

    const getAllBranchs = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-branchs-ticket');
        const branchsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.branch_id,
            };
        })
        setBranchs(branchsArray);
    };

    const getSchedulesDay = async (branch) => {
        setLoading(true);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const dateFormat = year + '-' + month + '-' + day;
        const form = new FormData();
        form.append('branch_id', branch);
        form.append('date', dateFormat);
        const response = await axios.post(ENDPOINT + 'get-schedules-day', form);
        const timeArray = response.data.data.map(function (element) {
            return {
                label: element.time,
                value: element.time
            };
        })
        setTimes(timeArray);
        setLoading(false);
    };

    const handleSearch = async () => {
        const form = new FormData();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const dateFormat = year + '-' + month + '-' + day;
        form.append('branch_id', branch_id);
        form.append('date', dateFormat);
        form.append('time', time);
        setLoading(true);
        await axios.post(ENDPOINT + 'seach-binnacle', form).then(response => {
            setLoading(false);
            setBinnacles(response.data.data);
            var table = $('.main').DataTable();
            table.destroy();
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 50,
                    responsive: false,
                    autoWidth: true,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay registros",
                        "searchPlaceholder": "Buscar...",
                    },
                });
                setLoading(false);
            }, 100);
        }).catch(function (error) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const handlePrint = async () => {
        Swal.fire({
            icon: 'info',
            title: '<div class="title-custom-alert">¡Atención!</div>',
            html: '<div class="text-custom-alert">Taquillero recuerda pedir la bitácora y pedir la paquetería en caso de ser necesario</div>',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            showClass: { popup: 'animate__animated animate__fadeInDown' },
            hideClass: { popup: 'animate__animated animate__fadeOutUp' }
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, "0");
                const day = date.getDate().toString().padStart(2, "0");
                const date_send = year + '-' + month + '-' + day;
                const user = JSON.parse(localStorage.getItem('dataUser'));
                const user_id = user.user_id;
                const form = new FormData();
                form.append('branch_id', branch_id);
                form.append('date', date_send);
                form.append('time', time);
                form.append('user_id', user_id);
                await axios.post(ENDPOINT + 'print-pdf-binnacle', form, { responseType: "blob" })
                    .then((response) => {
                        const url = window.URL.createObjectURL(response.data);
                        window.open(url, '_blank');
                        setLoading(false);
                    }).catch(function (error) {
                        setLoading(false);
                        Swal.fire({
                            icon: 'error',
                            title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                            showConfirmButton: true,
                            html: '<div class="text-custom-alert">No hay datos para generar el reporte</div>',
                            showClass: { popup: 'animate__animated animate__fadeInDown' },
                            hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                        })
                    });
            }
        });
    };

    return (
        <>
            {loading && <Loader />}

            <div className="container-fluid">
                <ContentHeader title="Módulo de Bitacora" />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-journal-text me-2"></i> Bitacora de Viajes
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="indications row mb-4">
                            <div className="col-md-3 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="branch_id" className="col-form-label col-form-label-sm">
                                        Base
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="branch_id"
                                        name="branch_id"
                                        required
                                    >
                                        <option selected value="">Seleccione base</option>
                                        {branchs.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="binnacle-field-hint">Seleccione la base de operaciones</small>
                                </div>
                            </div>
                            <div className="col-md-2 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="date" className="col-form-label col-form-label-sm">
                                        Fecha 
                                    </label>
                                    <br/>
                                    <DatePicker
                                        showIcon
                                        locale="es"
                                        selected={date}
                                        onChange={(date) => setDate(date)}
                                        onCalendarClose={handleCalendarClose}
                                        className="form-control form-control-sm"
                                        icon="fa fa-calendar"
                                        required
                                        dateFormat="dd, MMMM, yyyy"
                                    />
                                    <small className="binnacle-field-hint">Seleccione la fecha del viaje</small>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 mb-2">
                                <div className="form-group">
                                    <label htmlFor="time" className="col-form-label col-form-label-sm">
                                        Hora
                                    </label>
                                    <select
                                        className="form-control form-control-sm select2"
                                        id="time"
                                        name="time"
                                        required
                                    >
                                        <option selected value="">Seleccione horario</option>
                                        {times.map((item, index) => (
                                            <option key={index} value={item.value}>{item.label}</option>
                                        ))}
                                    </select>
                                    <small className="binnacle-field-hint">Seleccione la hora del viaje</small>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-6 mb-3" style={{ display: "flex", justifyContent: 'start', alignItems: "center" }}>
                                <button
                                    onClick={() => handleSearch()}
                                    className="btn btn-primary btn-sm me-1">
                                    <i className="fa fa-search me-1"></i> Buscar
                                </button>
                                <button
                                    onClick={() => handlePrint()}
                                    className="btn btn-danger btn-sm me-1">
                                    <i className="fa-solid fa-file-pdf me-1"></i> Descargar
                                </button>
                            </div>
                        </div>
                        <table className="table table-hover main table-striped">
                            <thead>
                                <tr>
                                    <th width="10%" className="text-center">Asiento</th>
                                    <th width="20%" className="text-left">Pasajero</th>
                                    <th width="20%" className="text-left">Origen</th>
                                    <th width="20%" className="text-left">Destino</th>
                                    <th width="10%" className="text-center">Precio</th>
                                    <th width="10%" className="text-center">Folio</th>
                                    <th width="10%" className="text-center">Taquillero</th>
                                </tr>
                            </thead>
                            <tbody>
                                {binnacles.map((item, index) => (
                                    <tr key={index}>
                                        <td className="text-center">
                                            {item.seat}
                                        </td>
                                        <td>
                                            {item.name} {item.last_name}
                                        </td>
                                        <td>
                                            {item.origin.name}
                                        </td>
                                        <td>
                                            {item.destination.name}
                                        </td>
                                        <td className="text-center">
                                            {item.price_ticket}
                                        </td>
                                        <td className="text-center">
                                            {item.invoice}
                                        </td>
                                        <td className="text-center">
                                            {item.name_user}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Binnacle;